/**
 * Helper to determine in the checkbox is checked.
 *
 * @param value
 */
export function checked(value: any = null) {
  return ["on", true, "true", 1, "1", "ja"].includes(value);
}

/**
 * Helper to get the value from a input change event.
 *
 * @param event
 */
export function getValueFromEvent(event: any) {
    return getValueFromElement(event.target);
}

export function getValueFromElement(element: any) {
  let value: string | any[] = "";

  if (element.multiple) {
    if ("file" === element.type) {
      value = Array.prototype.map.call(element.files, (file) => file);
    } else if ("checkbox" === element.type) {
      if (element.value) {
        value = element.checked ? element.value : "";
      } else {
        value = element.checked ? "1" : "0";
      }
    } else {
      value = Array.prototype.map.call(
        element.selectedOptions,
        (selectedOption) => selectedOption.value
      );
    }
  } else {
    if ("file" === element.type) {
      value = element.files[0];
    } else if ("checkbox" === element.type) {
      if (element.value) {
        value = element.checked ? element.value : "";
      } else {
        value = element.checked ? "1" : "0";
      }
    } else {
      value = element.value;
    }
  }

  return value;
}
